import { useTranslation } from 'react-i18next';

import type { RiskObjectMinimal, RiskObjectProperty } from '../types';

type Props<T extends RiskObjectMinimal> = {
  config: RiskObjectProperty<T>;
  riskObject: T;
};

export default function RiskObjectProperty<T extends RiskObjectMinimal>({
  config,
  riskObject,
}: Props<T>) {
  const { t } = useTranslation();

  const value = config.getValue(riskObject);

  const isEmpty = value === undefined || value === null;

  if (isEmpty) return null;

  return (
    <div className="flex flex-col">
      <p className="text-muted-foreground text-[10px] uppercase">
        {t(config.label)}
      </p>

      {!isEmpty && <p className="text-sm">{value}</p>}

      {isEmpty && <span className="text-muted-foreground text-sm">{'-'}</span>}
    </div>
  );
}
